export default {
	token: '',
	status: false,
	statusValue: false,
	profiles: ['PERSONAL', 'SEDE', 'AGENT']
};
